import Axios from "axios";

import { SET_TAX_REGISTER_LIST, UNSET_TAX_REGISTER_LIST } from "@/store/mutation-types";


import {
  getTaxRegister as getTaxRegisterApi,
  taxPayout as taxPayoutApi
} from "@/store/api";

const state = {
  getTaxRegisterList: [],
};


const getters = {
  getTaxRegisterList(state) {
    return state.getTaxRegisterList;
  },
};


// Mutations
const mutations = {
  [SET_TAX_REGISTER_LIST](state, data) {
    state.getTaxRegisterList = data;
  },
  [UNSET_TAX_REGISTER_LIST](state) {
    state.getTaxRegisterList = [];
  },
};

// Actions
const actions = {
  /**
   * Get voucher list by type
   */
  getTaxRegisterList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${getTaxRegisterApi}`, { params: data })
        .then((response) => {
          commit(SET_TAX_REGISTER_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_TAX_REGISTER_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
  storeTaxPayout({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(taxPayoutApi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },
};


export default {
  state,
  getters,
  actions,
  mutations,
};